// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom'; // ✅ 추가

const Footer = () => {
  const footerLinks = [
    { name: 'About Us', path: '/about-us' },
    { name: 'Terms of Service', path: '/terms' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Youth Protection Policy', path: '/youth' },
    { name: 'Legal Notice & Disclaimer', path: '/disclaimer' },
    { name: 'Email Collection Refusal', path: '/email' },
    { name: 'Seller Partnership Inquiry', path: '/seller-inquiry' }
  ];

  return (
    <footer className="bg-white border-t border-gray-200 py-12 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-gray-900 font-light text-lg">Namsan Bro</p>
          <div className="flex flex-wrap justify-center gap-6 mt-6 text-sm text-gray-600">
            {footerLinks.map((link) => (
              <Link 
                key={link.path}
                to={link.path}
                className="hover:text-gray-900"
              >
                {link.name}
              </Link>
            ))}
          </div>
          <div className="border-t border-gray-200 mt-8 pt-8 text-center text-sm text-gray-500">
            © 2025 Namsan Bro. Built for the Canadian market.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;